import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';   // ← was KFXApp.jsx — removed the broken wrapper
import './styles/global.css';
import "./styles/sidebar-topbar-overrides.css";
import './styles/trade-modal-fixes.css'; // ← add this line

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);